import React from "react";
import { useNavigate } from "react-router-dom";

/**
 * 所定運用の車号。
 *
 * 乗番一覧と路線別一覧の両方で同じ見た目にする。**同じものが画面によって
 * 別物に見えないように**、VehicleChange と同じ理由で部品にしてある。
 *
 * 所定は「いつも入っている車」であって、今日その車が入っているという意味では
 * ない。今日の話は「本日充当」が持つ。取り違えられないように、確からしさ
 * （10日中9日）を必ず添える。
 *
 * regular が null なら「—」。**所定が無いのか、まだ決められないのかは
 * ここでは区別しない**（窓が埋まっていない営業所では全部が null になる）。
 * その断り書きは表の下の注記が持つ。
 */
export default function RegularBus({ regular }) {
  const navigate = useNavigate();

  if (!regular) {
    return <span style={{ color: "#9ca3af" }}>—</span>;
  }

  const { bus_number: busNumber, depot, days, window_days: windowDays } = regular;

  return (
    <span style={{ display: "inline-block", whiteSpace: "nowrap" }}>
      <button
        className="anl-link"
        onClick={(e) => {
          e.stopPropagation();
          navigate(
            `/analysis/buses/${encodeURIComponent(busNumber)}` +
              (depot ? `?depot=${encodeURIComponent(depot)}` : "")
          );
        }}
        title={`直近${windowDays}営業日のうち${days}日この乗番に入っています`}
      >
        {busNumber}
      </button>
      <span style={{ color: "#9ca3af", fontSize: ".75rem", marginLeft: ".25rem" }}>
        {days}/{windowDays}
      </span>
    </span>
  );
}
